import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { graphql, gql, compose } from 'react-apollo';

import Snackbar from 'material-ui/Snackbar';

import RegListForm from '../RegListForm';

const createOrUpdateRegListMutation = gql`
    mutation CreateOrUpdateRegListMutation($season: String, $input: RegListInput) {
        createOrUpdateRegList(season: $season, input: $input) {
            _id
            townName
            population
            orgHeadName
            address
            addressee
            orgHeadPosition
            juryHeadName
            juryHeadPosition
            email
            phone
            invitations
            pDate
            mDate
            tDate
            vDate
            pPapersNumber
            mPapersNumber
            tPapersNumber
            vPapersNumber
            participantsNumber
            sentPPapersNumber
            sentMPapersNumber
            sentTPapersNumber
            sentVPapersNumber
            sentParticipantsNumber
            payment
            paymentData
            rulesAreFollowed
            ruleBreakersList
            comments
            season
        }
    }
`;

class RegList extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        regList: PropTypes.object,
        season: PropTypes.string.isRequired,
        mutate: PropTypes.func.isRequired,
        onSave: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            error: '',
        };

        if (!props.regList) {
            this.state.regList = {
                season: props.season,
                email: props.email,
                townName: props.townName,
            };
        }
    }

    handleSubmit = ({ season, ...input }) => {
        const {
            intl: { formatMessage },
        } = this.props;

        Object.keys(input).forEach(key => {
            if (input[key] === '') {
                input[key] = null;
            }
        });

        this.props
            .mutate({ variables: { season, input } })
            .then(regList => {
                this.props.onSave(regList);
            })
            .catch(() => {
                this.setState({ error: formatMessage({ id: 'RegList.global error' }), saving: false });
            });
    };

    render() {
        const { editable } = this.props;
        const regList = this.props.regList || this.state.regList;

        return (
            <div>
                <RegListForm
                    onSubmit={this.handleSubmit}
                    regList={regList}
                    editable={editable}
                    season={regList.season}
                />
                <Snackbar
                    open={!!this.state.error}
                    message={this.state.error}
                    autoHideDuration={10000}
                    onRequestClose={() => this.setState({ error: '' })}
                />
            </div>
        );
    }
}

export default compose(
    graphql(createOrUpdateRegListMutation),
    injectIntl
)(RegList);



// WEBPACK FOOTER //
// ./src/Components/RegList/RegList.js